var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKidIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 305,
    viewBox: "0 0 316 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.323 30.2795H183.539V132.261H257.323V30.2795Z",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M248.25 42.8211H192.609V119.729H248.25V42.8211Z",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212.145 262.503H169.354L138.441 279.142H185.101L212.145 262.503Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.91 266.53H201.256",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M163.941 269.119H196.288",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.977 271.707H191.323",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.016 274.305H186.362",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.441 279.142V282.01H186.074L185.101 279.142H138.441Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M186.074 282.01L213.398 264.951L212.145 262.503L185.102 279.142L186.074 282.01Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M139.212 278.272C139.139 277.985 139.102 277.689 139.102 277.393C139.102 276.739 139.296 276.1 139.661 275.556C140.026 275.012 140.544 274.588 141.15 274.338C141.756 274.088 142.423 274.022 143.066 274.15C143.71 274.277 144.301 274.592 144.765 275.055",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M143.552 276.274C143.479 275.989 143.442 275.697 143.441 275.404C143.442 274.75 143.636 274.111 144.001 273.567C144.365 273.023 144.884 272.6 145.49 272.349C146.096 272.099 146.763 272.033 147.406 272.161C148.05 272.289 148.641 272.603 149.105 273.066",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M147.55 274.275C147.474 273.991 147.434 273.699 147.43 273.406C147.433 272.752 147.629 272.113 147.995 271.57C148.361 271.027 148.88 270.605 149.486 270.355C150.092 270.105 150.759 270.039 151.403 270.166C152.046 270.293 152.638 270.606 153.103 271.067",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151.382 272.186C151.301 271.904 151.261 271.611 151.262 271.317C151.265 270.663 151.462 270.025 151.827 269.482C152.193 268.939 152.712 268.516 153.318 268.266C153.924 268.016 154.591 267.951 155.235 268.077C155.878 268.204 156.47 268.518 156.935 268.979",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M155.63 269.728C155.557 269.444 155.52 269.152 155.52 268.859C155.52 268.205 155.714 267.565 156.079 267.022C156.444 266.478 156.962 266.054 157.568 265.804C158.174 265.553 158.841 265.488 159.484 265.615C160.128 265.743 160.719 266.058 161.183 266.52",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M160.183 267.18C160.102 266.897 160.062 266.604 160.063 266.31C160.063 265.656 160.257 265.017 160.622 264.473C160.987 263.929 161.505 263.506 162.111 263.255C162.717 263.005 163.384 262.94 164.027 263.067C164.671 263.195 165.262 263.51 165.726 263.972",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M162.632 265.651C162.551 265.368 162.511 265.075 162.512 264.781C162.51 264.126 162.703 263.486 163.067 262.94C163.431 262.395 163.949 261.97 164.555 261.718C165.162 261.467 165.83 261.4 166.474 261.528C167.118 261.655 167.71 261.97 168.175 262.433",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M217.879 272.446C217.879 272.446 221.137 279.601 215.734 281.66L247.81 302.186C247.81 302.186 250.927 303.975 254.897 300.417C258.866 296.86 255.558 289.055 253.774 288.066C251.99 287.076 217.879 272.446 217.879 272.446Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M258.072 256.167L216.574 272.047L249.772 290.034C251.512 291.228 252.961 292.795 254.012 294.621C254.204 295.084 254.355 295.562 254.463 296.05C254.661 296.961 254.587 297.909 254.251 298.778C253.915 299.648 253.331 300.4 252.571 300.943C251.812 301.485 250.91 301.795 249.976 301.833C249.042 301.871 248.118 301.636 247.316 301.157L215.732 281.7C215.732 281.7 212.795 281.7 216.153 284.208C218.939 286.267 240.37 299.258 247.176 303.255C247.865 303.663 248.637 303.911 249.436 303.98C250.234 304.049 251.038 303.938 251.787 303.655L297.064 285.378C297.727 284.941 298.292 284.372 298.724 283.706C299.155 283.04 299.443 282.293 299.57 281.51C299.834 279.951 299.574 278.349 298.828 276.953C298.083 275.557 296.895 274.447 295.45 273.795L258.072 256.167Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M315 258.656H1",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7422 234.062C70.7422 234.062 77.869 228.216 89.6066 234.901",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8968 236.92L86.3089 238.919C86.3089 238.919 95.3302 235.251 96.1221 239.329C96.9139 243.406 90.8095 244.635 89.1657 244.635C87.5218 244.635 83.4422 244.225 81.8083 244.635C80.1745 245.045 78.1297 247.073 74.451 247.483C74.451 247.483 64.2269 251.56 60.1373 249.112C56.0476 246.664 59.3153 238.119 64.6379 235.251C69.9604 232.383 76.8968 236.92 76.8968 236.92Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9378 239.938C55.9378 239.938 51.9283 237.56 50.6653 240.588C49.4023 243.616 45.7237 250.641 48.0191 250.011C50.3145 249.382 55.9378 239.938 55.9378 239.938Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1797 235.701C62.1797 235.701 55.5842 234.991 54.8123 236.92C53.389 240.508 51.5447 250.381 54.4114 251.191C57.2782 252 58.0901 245.894 59.7239 242.197C60.6771 240.084 61.4973 237.915 62.1797 235.701Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8587 231.624C65.8587 231.624 60.9472 231.214 59.3133 234.482C57.6795 237.75 56.7272 250.811 58.311 250.811C59.8947 250.811 59.4937 252.1 61.9495 246.814C63.1524 244.225 64.9566 235.711 64.9566 235.711L65.8587 231.624Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0783 238.029C78.0783 238.029 71.563 232.493 69.8489 231.544C68.1349 230.594 66.9722 230.205 65.0577 231.924C63.1431 233.642 62.7622 239.748 61.2387 243.566C59.7151 247.383 58.1714 251.38 60.0859 251.38C62.0004 251.38 63.7245 250.431 65.2481 248.382C66.7717 246.334 69.6585 238.839 69.6585 238.839",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0783 238.029C78.0783 238.029 71.563 232.493 69.8489 231.544C68.1349 230.594 66.9722 230.205 65.0577 231.924C63.1431 233.642 62.7622 239.748 61.2387 243.566C59.7151 247.383 58.1714 251.38 60.0859 251.38C62.0004 251.38 63.7245 250.431 65.2481 248.382C66.7717 246.334 69.6585 238.839 69.6585 238.839",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6992 242.607C68.6992 242.607 70.9946 243.607 74.2523 241.457L68.6992 242.607Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6992 242.607C68.6992 242.607 70.9946 243.607 74.2523 241.457",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M185.442 240.538C185.442 240.538 178.867 237.69 177.764 237.69C176.841 238.803 176.304 240.184 176.23 241.627C176.23 243.815 176.451 252.779 177.544 253.219C178.636 253.659 181.934 251.69 184.129 248.632C186.324 245.574 186.755 241.187 185.442 240.538Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M180.399 259.125L176.891 258.466L178.204 263.282L180.399 259.125Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M182.707 226.667C182.461 226.636 182.211 226.655 181.973 226.722C181.734 226.788 181.511 226.902 181.317 227.055C181.123 227.209 180.962 227.399 180.842 227.616C180.723 227.832 180.648 228.07 180.622 228.316L180.141 232.213L183.799 232.943L184.351 228.726C184.404 228.236 184.262 227.745 183.954 227.359C183.646 226.974 183.198 226.725 182.707 226.667Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M211.304 191.781H141.84C133.22 191.121 132.699 194.539 132.699 194.539L119.668 258.685H205.43C205.881 255.478 212.647 208.04 213.92 200.375C215.253 192.44 211.304 191.781 211.304 191.781Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M211.308 191.781H211.178C210.677 191.781 208.802 192.28 207.66 197.397C206.517 202.513 199.992 246.484 198.188 258.685H205.465C205.916 255.478 212.682 208.04 213.955 200.375C215.258 192.44 211.308 191.781 211.308 191.781Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6709 258.685H179.511C179.09 246.084 177.507 200.645 176.304 195.008C174.921 188.453 171.462 187.424 166.621 187.074C161.78 186.724 158.181 187.973 148.498 187.973C138.815 187.973 129.453 186.974 129.453 186.974C129.453 186.974 125.654 186.624 123.58 186.624C121.505 186.624 120.121 188.003 117.355 188.003C112.387 188.066 107.42 187.836 102.48 187.314C97.2876 186.624 91.063 189.382 90.0305 194.559C89.1284 199.056 87.0234 246.783 86.4922 259.085H98.6508L98.6709 258.685Z",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M122.016 194.019C122.016 194.019 124.872 207.69 132.861 211.098",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M114.588 191.741C114.588 191.741 110.578 200.285 116.302 212.806",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M161.988 209.399C161.988 209.399 152.857 232.733 132.859 243.556",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M124.289 179.009C124.289 179.009 124.981 188.663 126.013 194.179C127.046 199.695 132.929 203.173 139.505 201.074C146.08 198.976 148.837 194.529 149.188 191.421C149.539 188.313 149.529 176.601 149.529 176.601C149.529 176.601 139.134 183.496 124.289 179.009Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M159.776 124.086C159.776 124.086 160.718 122.837 158.212 119.09C155.706 115.342 149.752 112.844 149.752 112.844L153.511 117.841C153.511 117.841 142.866 112.224 138.475 112.224C134.085 112.224 123.099 113.783 123.099 113.783L128.422 115.032C128.422 115.032 115.271 119.09 113.707 120.958C112.143 122.827 104.626 129.083 106.189 129.083C107.753 129.083 115.581 127.834 115.581 127.834C115.581 127.834 107.753 135.329 107.753 138.447C107.753 141.565 114.639 156.554 114.639 156.554C114.639 156.554 119.34 164.989 120.904 160.921C122.468 156.854 119.962 147.191 120.283 146.251C120.603 145.312 138.756 143.753 142.826 143.753C146.895 143.753 146.274 153.437 147.837 154.995C149.401 156.554 156.959 159.353 158.182 159.353C159.405 159.353 161.63 158.423 161.63 157.174C161.707 154.5 162.236 151.858 163.194 149.359C164.447 146.231 166.01 143.423 166.321 139.676C166.632 135.928 164.447 127.504 164.447 127.504H167.263C167.263 127.504 164.477 122.837 159.776 124.086Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M116.251 154.356C116.251 154.356 114.677 148.43 111.86 152.487C110.046 155.105 114.677 165.598 117.183 166.228C119.689 166.857 116.251 154.356 116.251 154.356Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M116.25 142.504C116.25 142.504 116.25 165.298 117.814 170.915C119.377 176.531 125.642 184.965 134.724 184.965C143.805 184.965 150.07 180.278 152.576 176.851C155.082 173.423 156.324 166.548 156.324 166.548C156.324 166.548 159.151 168.736 162.589 164.669C166.027 160.602 166.528 153.387 165.095 152.497C162.589 150.938 159.773 152.807 158.52 154.056L156.014 156.554C156.014 156.554 151.944 153.746 151.944 149.999C151.944 146.251 152.576 139.386 152.576 139.386L149.749 141.255L150.07 138.756C150.07 138.756 149.438 139.386 145.679 139.386C141.92 139.386 132.839 140.006 132.839 140.006L137.54 133.76C137.54 133.76 128.459 137.827 125.331 139.696C122.204 141.564 116.25 142.504 116.25 142.504Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M128.023 156.185C128.023 157.873 127.351 159.253 126.519 159.253C125.687 159.253 125.016 157.873 125.016 156.185C125.016 154.496 125.687 153.117 126.519 153.117C127.351 153.117 128.023 154.496 128.023 156.185Z",
    fill: "#699595"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M142.515 156.604C142.515 158.293 141.843 159.662 141.011 159.662C140.179 159.662 139.508 158.293 139.508 156.604C139.508 154.916 140.179 153.536 141.011 153.536C141.843 153.536 142.515 154.906 142.515 156.604Z",
    fill: "#699595"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M130.527 163.43C130.527 163.43 130.527 167.817 135.98 166.768",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M128.852 171.345C128.852 171.345 133.252 174.055 139.336 171.135",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M121.094 150.259C121.63 149.286 122.485 148.526 123.516 148.108C124.548 147.689 125.692 147.637 126.757 147.96",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M138.07 147.96C138.07 147.96 143.082 146.501 144.987 149.849",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6536 192.57L76.7609 230.714C76.7609 230.714 67.8599 237.16 66.9076 238.829C64.512 242.996 67.6293 248.912 70.5061 252C75.0368 256.847 84.2485 257.536 89.7615 253.939C93.38 251.58 95.505 246.784 96.8682 242.836L98.3317 209.319",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M165.02 186.804C165.02 186.804 172.848 185.305 176.647 189.102C180.446 192.9 191.382 221.381 195.191 231.074C199 240.768 202.799 247.623 201.756 252.45C200.714 257.276 192.735 258.995 186.891 259.345C180.245 259.735 175.865 255.548 175.865 254.169C175.865 252.789 173.439 249.692 177.94 238.999L174.823 216.244",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M180.623 228.306L176.895 258.456L178.228 263.282L180.423 259.125L184.372 228.726C184.426 228.236 184.283 227.745 183.975 227.359C183.667 226.974 183.219 226.725 182.728 226.667C182.482 226.634 182.231 226.65 181.99 226.714C181.75 226.779 181.525 226.891 181.329 227.044C181.133 227.197 180.969 227.387 180.848 227.604C180.727 227.821 180.65 228.059 180.623 228.306Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M177.769 237.69C176.676 237.69 174.481 240.538 173.168 242.067C171.855 243.596 172.286 246.873 173.379 249.502C174.471 252.13 174.922 256.937 176.235 257.156C177.548 257.376 178.651 256.067 178.651 253.659C178.651 251.25 178.21 246.224 178.21 246.224",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M177.769 237.69C176.676 237.69 174.481 240.538 173.168 242.067C171.855 243.596 172.286 246.873 173.379 249.502C174.471 252.13 174.922 256.937 176.235 257.156C177.548 257.376 178.651 256.067 178.651 253.659C178.651 251.25 178.21 246.224 178.21 246.224",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M192.461 253.219C192.461 253.219 194.005 257.376 192.251 259.565C190.497 261.753 184.783 260.874 183.691 260.005C182.598 259.135 188.522 257.596 192.461 253.219Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M191.81 249.292C192.393 249.933 192.783 250.724 192.938 251.576C193.092 252.427 193.003 253.305 192.682 254.109C191.59 256.947 187.671 259.355 184.784 259.795C181.897 260.234 179.521 258.695 180.844 257.796C182.168 256.897 188.733 252.57 191.81 249.292Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M189.173 244.475C189.173 244.475 191.81 246.873 191.81 249.282C191.81 251.69 185.445 257.376 182.377 258.466C179.31 259.555 177.767 258.466 178.649 256.467C179.531 254.468 188.301 244.665 188.301 244.665C188.301 244.665 187.86 244.035 189.173 244.475Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M181.716 244.475C181.716 244.475 176.895 252.779 176.233 255.408C175.572 258.036 177.987 258.036 179.521 256.937C181.055 255.837 188.302 247.093 189.174 244.475C190.046 241.857 188.522 239.009 185.666 239.478C182.809 239.948 181.716 244.475 181.716 244.475Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M142.412 257.956H61.4011L30.4883 274.605H115.358L142.412 257.956Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M66.707 262.313H126.518",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3477 265.411H122.159",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9766 268.519H117.798",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M126.83 262.313L109.699 270.697",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M117.486 262.313L100.355 270.697",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M16 216.514H100.88L115.364 274.605H30.4942L16 216.514Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4833 278.732H115.363V274.605H30.4833V278.732Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0547 216.514H99.9347L114.429 274.605H29.5488L15.0547 216.514Z",
    fill: "white",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M115.363 274.605L142.417 257.956V261.374L115.363 278.732V274.605Z",
    fill: "#699595",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M68.431 243.795C68.5646 244.662 68.4432 245.548 68.0813 246.347C67.7194 247.146 67.1328 247.823 66.3925 248.296C65.6522 248.768 64.7902 249.017 63.911 249.011C63.0319 249.004 62.1735 248.744 61.44 248.261C60.7064 247.778 60.1294 247.092 59.7789 246.289C59.4283 245.485 59.3194 244.597 59.4653 243.732C59.6112 242.868 60.0056 242.065 60.6007 241.419C61.1958 240.774 61.966 240.315 62.8177 240.098C64.0535 239.85 65.3375 240.1 66.3893 240.793C67.441 241.485 68.175 242.565 68.431 243.795Z",
    stroke: "#699595",
    strokeWidth: 1.25474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidIllustration);
export default __webpack_public_path__ + "static/media/KidIllustration.5713c382d91ea7ea6e5599344b49cad1.svg";
export { ForwardRef as ReactComponent };